import React, { useEffect } from 'react';
import './Modal.css';

const DisclaimerModal = ({ closeModal }) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    return (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && closeModal()}>
            <div className="modal-box" style={{ maxWidth: '800px', maxHeight: '85vh' }}>
                <button className="modal-close" onClick={closeModal}>×</button>
                <div className="modal-header">
                    <h2>Disclaimer</h2>
                    <img src="/assets/Embracelogo.png" alt="Embrace" />
                </div>
                
                <div style={{ paddingRight: '10px', fontSize: '14px', lineHeight: '1.6', color: 'var(--mid-gray)', textAlign: 'left' }}>
                    <p style={{ marginBottom: '15px' }}><strong>Last Updated: {new Date().toLocaleDateString()}</strong></p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>1. General Information</h3>
                    <p style={{ marginBottom: '15px' }}>The information provided on the Embrace Beauty Aesthetics website is for general informational and educational purposes only. It is not intended as a substitute for professional medical advice, diagnosis, or treatment.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>2. Medical Disclaimer</h3>
                    <p style={{ marginBottom: '15px' }}>Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition or treatment before undertaking a new healthcare regimen. Never disregard professional medical advice or delay in seeking it because of something you have read on this website.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>3. Treatment Results</h3>
                    <p style={{ marginBottom: '15px' }}>Results from our treatments may vary from person to person. Before and after photos, testimonials, and other examples on this website are not a guarantee of specific results.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>4. External Links</h3>
                    <p style={{ marginBottom: '15px' }}>Our website may contain links to third-party websites. Embrace Beauty Aesthetics is not responsible for the content, privacy policies, or practices of any external sites.</p>
                    
                    <h3 style={{ fontSize: '18px', color: 'var(--dark)', marginTop: '20px', marginBottom: '10px' }}>5. Limitation of Liability</h3>
                    <p style={{ marginBottom: '15px' }}>By using this website, you agree that Embrace Beauty Aesthetics, its employees, and affiliates will not be liable for any direct, indirect, or consequential loss or damage arising from your use of the site or reliance on any information provided.</p>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerModal;
